import HeaderView from '../../components/header'
import api from '../../services/service'

export default {
  components: {
    HeaderView
  },
  data () {
    return {
      username: '',
      password: '',
      required: false,
      user_msg: '',
      pwd_msg: '',
      user_status: '',
      pwd_status: ''
    }
  },
  methods: {
    validateUserEmpty () {
      if (!this.username) {
        this.user_status = 'error'
        this.user_msg = 'Please Enter Your username'
      } else {
        this.user_status = 'success'
        this.user_msg = ''
      }
      this.required = false
    },
    validatePassEmpty () {
      if (!this.password) {
        this.pwd_status = 'error'
        this.pwd_msg = 'Please Enter Your password'
      } else {
        this.pwd_status = 'success'
        this.pwd_msg = ''
      }
      this.required = false
    },
    doLogin () {
      this.validatePassEmpty()
      this.validateUserEmpty()
      if (this.username && this.password) {
        var payload = {
          username: this.username,
          password: this.password
        }
        this.$store.state.isLoading = true
        api.Login(payload,
          (result) => {
            if (result.result === true) {
              this.required = false
              sessionStorage.user = JSON.stringify(result.data)
              this.$notification['success']({
                message: 'เข้าสู่ระบบ',
                description: 'ยินดีต้อนรับ คุณ ' + result.data.fullname,
              })
              this.$router.push('/admin')
            } else {
              this.required = true
            }
            this.$store.state.isLoading = false
          },
          // eslint-disable-next-line handle-callback-err
          (error) => {
            console.log(error)
            this.required = true
            this.$store.state.isLoading = false
          }
        )
      }
    }
  },
  mounted () {
    if (sessionStorage.user !== undefined) {
      this.$router.push('/admin')
    }
    if (this.$route.name !== 'login') {
      this.$router.push({ name: 'login' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/login.js